import { render, staticRenderFns } from "./MultilineTextarea.vue?vue&type=template&id=96b8e024&scoped=true&"
import script from "./MultilineTextarea.vue?vue&type=script&lang=js&"
export * from "./MultilineTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MultilineTextarea.vue?vue&type=style&index=0&id=96b8e024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8e024",
  null
  
)

export default component.exports